import { globalActions } from '../../global-actions';

export const getActionTypes = (actionPrefix) => ({
  QUERY_START: `${actionPrefix}_QUERY_START`,
  QUERY_SUCCESS: `${actionPrefix}_QUERY_SUCCESS`,
  QUERY_FAILURE: `${actionPrefix}_QUERY_FAILURE`,
});

export const getActions = (actionPrefix) => ({
  // START
  setQueryStart: (isInfinite) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_START,
      payload: { isInfinite },
    });
  },

  // SUCCESS
  setQuerySuccess: (data) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_SUCCESS,
      payload: { data },
    });
  },

  // FAILURE
  setQueryFailure: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).QUERY_FAILURE,
      payload: { error },
    });
  },
});
